// extracted by mini-css-extract-plugin
export default {"label":"chat_attachment_input___label___e0e0aee0","disabled":"chat_attachment_input___disabled___b4f743ef","input":"chat_attachment_input___input___f4595788"};